import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import { Icon } from "@iconify/react";
import CountUp from "react-countup";
import { useScrollAnimation } from "../../hooks/useScrollAnimation";
import FadeUp from "../UI/FadeUp";
import "swiper/css";
import "./Testimonials.css";

const RatingStars = ({ value, max = 5, size = 16, activeColor = "#FFD700" }) => {
  const stars = [];
  const fullStars = Math.floor(value);
  const hasHalf = value % 1 !== 0;

  for (let i = 1; i <= max; i++) {
    if (i <= fullStars) {
      stars.push(
        <Icon
          key={i}
          icon="mdi:star"
          style={{ color: activeColor, fontSize: `${size}px` }}
        />
      );
    } else if (i === fullStars + 1 && hasHalf) {
      stars.push(
        <Icon
          key={i}
          icon="mdi:star-half-full"
          style={{ color: activeColor, fontSize: `${size}px` }}
        />
      );
    } else {
      stars.push(
        <Icon
          key={i}
          icon="mdi:star-outline"
          style={{ color: "#D1D5DB", fontSize: `${size}px` }}
        />
      );
    }
  }

  return <div style={{ display: "flex", gap: "2px" }}>{stars}</div>;
};

const reviews = [
  { id: 1, text: "The delivery is insanely fast! Food arrives hot and the packaging is always intact. Highly recommended.", name: "Rahul S.", city: "Patna", rating: 5, avatar: "https://i.pravatar.cc/150?u=1" },
  { id: 2, text: "Best food delivery app I have ever used. The UI is so smooth and finding restaurants is a breeze.", name: "Priya M.", city: "Delhi", rating: 5, avatar: "https://i.pravatar.cc/150?u=2" },
  { id: 3, text: "Love the discounts and the variety of restaurants available. Never had a bad experience.", name: "Amit K.", city: "Mumbai", rating: 4.5, avatar: "https://i.pravatar.cc/150?u=3" },
  { id: 4, text: "Customer service is top notch. They quickly resolved an issue with my order.", name: "Neha G.", city: "Bangalore", rating: 5, avatar: "https://i.pravatar.cc/150?u=4" }
];

export const Testimonials = () => {
  return (
    <section className="testimonials-section">
      <div className="testimonials-container">
        <FadeUp>
          <h2 className="section-title">What Our Customers Say</h2>
        </FadeUp>
        
        <FadeUp delay={0.2}>
          <Swiper
            modules={[Autoplay]}
            spaceBetween={30}
            slidesPerView={1}
            autoplay={{ delay: 4000, disableOnInteraction: false, pauseOnMouseEnter: true }}
            loop={true}
            breakpoints={{
              640: { slidesPerView: 1 },
              768: { slidesPerView: 2 },
              1024: { slidesPerView: 3 },
            }}
            className="testimonials-swiper"
          >
            {reviews.map(review => (
              <SwiperSlide key={review.id} style={{ height: 'auto' }}>
                <div className="testimonial-card">
                  <Icon icon="mdi:format-quote-close" className="quote-icon" />
                  <p className="review-text">"{review.text}"</p>
                  <div className="user-info">
                    <img src={review.avatar} alt={review.name} className="user-avatar" />
                    <div className="user-details">
                      <h4>{review.name}</h4>
                      <p>{review.city}</p>
                      <RatingStars value={review.rating} size={16} activeColor="#FFD700" />
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </FadeUp>
      </div>
    </section>
  );
};

export const Stats = () => {
  const { ref, inView } = useScrollAnimation();

  return (
    <section className="stats-section" ref={ref}>
      <div className="stats-grid">
        <div className="stat-item">
          <span className="stat-icon">🍽️</span>
          <h3 className="stat-number">{inView && <CountUp end={500} duration={2} />}+</h3>
          <p className="stat-label">Dishes</p>
        </div>

        <div className="stat-item">
          <span className="stat-icon">😊</span>
          <h3 className="stat-number">{inView && <CountUp end={50} duration={2} />},000+</h3>
          <p className="stat-label">Orders Delivered</p>
        </div>
        <div className="stat-item">
          <span className="stat-icon">⭐</span>
          <h3 className="stat-number">{inView && <CountUp end={4.8} decimals={1} duration={2} />}</h3>
          <p className="stat-label">Average Rating</p>
        </div>
      </div>
    </section>
  );
};
